import useSettings from '../useSettings/useSettings';

/**
 * @param	{string | string[]} subscriptionName
 * @returns	{boolean}
 */
export default function useIsFeatureActive(subscriptionName) {
	const settings = useSettings();

	if (Array.isArray(subscriptionName)) {
		return subscriptionName.some(
			(name) => settings.features.get(name) ?? false
		);
	}

	return settings.features.get(subscriptionName) ?? false;
}
